export default "__VITE_ASSET__CcXUbnYU__"